<template>
    <main>
        <div class="box">
            <div class="action">
                <div class="full-close" @click="hideVideo"></div>
            </div>
            <video :class="[video_play_show ? 'full' : '']" :controls="!video_play_show ? true : false" v-if="video_info.video"  x5-video-player-type="h5-page" :poster="video_info.image ?  util.autoImage(video_info.image) : util.autoImage(video_info.video)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'" :id="'video_float'" loop @click.prevent="hideVideo" >
                <source :src="util.autoImage(video_info.video)">
            </video>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'video-float',
        data() {
            return {
                video_play_show:true,
                flag:0
            }
        },
        props:{
            video_info:{
                type:Object,
                default:{},
            }
        },
        components:{

        },
        computed:{

        },
        methods: {
            playVideo(){
                var video = document.getElementById('video_float');
                video.addEventListener('play',()=>{
                    this.video_play_show = false;
                })
                // video.addEventListener('pause',()=>{
                //     this.video_play_show = true;
                //     this.hideVideo();
                // })
                video.play();
            },
            hideVideo(){
                this.$emit('hideVideo')
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.$nextTick(()=>{
                this.playVideo();
            })
        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 1000;background: #000;display:flex;flex-direction:column;
        video{width: 100%;flex: 1; ;object-fit: contain;z-index: 1000;}
        .action{height:.8rem;
            .full-close{width: .8rem;height:.8rem;position: fixed;top:0;right:0;background: url("~@/assets/image/m3.png") no-repeat center center;background-size: .29rem;z-index: 1001;}
        }
    }
</style>

